import { render, staticRenderFns } from "./FamiliaNova.vue?vue&type=template&id=70bd56dc"
import script from "./FamiliaNova.vue?vue&type=script&lang=js"
export * from "./FamiliaNova.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports